/**
 * Convierte un texto a número, tolerando coma como separador decimal.
 *
 * El teclado numérico del celular (`inputmode="decimal"`, configuración
 * regional en español) inserta una coma para los decimales (ej. "10,8"), no
 * un punto — pero `Number()`/`parseFloat()` de JS solo entienden el punto.
 * Sin esto, cualquier valor con coma da `NaN` en vez del número esperado
 * (hallazgo 2026-09-05, reportado desde la feria: precio FOB, precio de
 * venta, unidades por contenedor).
 *
 * @returns el número, o `undefined` si el texto está vacío o no es un
 *   número válido (ni siquiera reemplazando la coma).
 */
export function numeroDesdeTexto(valor: string | null | undefined): number | undefined {
  const limpio = (valor ?? '').trim().replace(',', '.')
  if (!limpio) return undefined
  const numero = Number(limpio)
  return Number.isNaN(numero) ? undefined : numero
}

/** Mismo criterio que `numeroDesdeTexto`, para validar sin necesitar el valor convertido. */
export function esNumeroDesdeTexto(valor: string | null | undefined): boolean {
  return numeroDesdeTexto(valor) !== undefined
}
